module.exports = "<div class=\"c-checkout-suggestions c-upsell\">\n    <span ng-if=\"$ctrl.content && $ctrl.content.body.text.length\" ng-bind-html=\"$ctrl.markdown($ctrl.content.body.text)\"></span>\n\n    <display-suggestions load-on-init=\"true\" can-load-staff=\"$ctrl.content.settings.load_staff\"></display-suggestions>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./frontend/storefront/app/modules/checkout/views/suggestions.html
// module id = 830
// module chunks = 0